/* eslint-disable new-cap */
import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import clipboard from 'clipboard-js';
import logger from 'utils/logger';
import _get from 'lodash/get';
import ContactDetailsBlock from 'containers/ContactDetailsBlock/ContactDetailsBlockContainer';
import classes from './ContactDetails.module.scss';

export class ContactDetails extends React.Component {
  copyCallingDetails = async () => {
    try {
      const isCustomContact =
        _get(this, 'props.contact.isGroupContact') || _get(this, 'props.contact.isPersonalContact');
      const callingDetails =
        _get(this, 'props.contact.dialString') ||
        _get(this, 'props.contact.extension') ||
        _get(this, 'props.contact.sipUri');
      const invitation = isCustomContact ? { body: callingDetails } : await this.props.getInviteForExtension();
      clipboard.copy({
        'text/plain': invitation.body
      });
    } catch (err) {
      logger.error(`Unable to copy invitation: ${err}`);
    }
  };

  render() {
    const { showCrudButtons, contact } = this.props;

    return (
      <div className={`${classes.detailsContainer} ${showCrudButtons ? classes.showCrudButtons : ''}`}>
        <div className={classes.detailsTitle}>
          <FormattedMessage id="components.contactDetails.callingDetails" defaultMessage="Calling Details" />
        </div>
        <section>
          <ContactDetailsBlock contact={contact} />
        </section>
        <section>
          <button
            onClick={this.copyCallingDetails}
            className={classes.copyCallDetailsButton}
            data-testid="copy-calling-details-btn"
          >
            <FormattedMessage id="settings.contactDetails.copyCallDetails" defaultMessage="Copy Calling Details" />
          </button>
        </section>
      </div>
    );
  }
}

ContactDetails.propTypes = {
  contact: PT.object.isRequired,
  getInviteForExtension: PT.func,
  showCrudButtons: PT.bool
};

export default ContactDetails;
